import * as yup from "yup";

export const EditContentValidator = yup.object().shape({
  title: yup
    .string()
    .required("title is required"), description: yup.string().required()
});

